import { useContent } from "@/lib/content";

const ITEMS = [
  "Innenstadt-Lage",
  "Persönlicher Service",
  "Frühstücksbuffet",
  "Restaurant & Bar",
  "Kostenfreie Parkplätze",
  "4 Min. zum Nonnenturm",
  "Wildpferde Merfelder Bruch",
];

export default function Marquee() {
  const c = useContent();
  const items = c.marquee_items?.length ? c.marquee_items : ITEMS;
  const row = [...items, ...items];
  return (
    <div
      className="relative overflow-hidden border-y border-forest/10 bg-cream py-5"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee gap-0">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8 pr-8 whitespace-nowrap">
            <span className="font-serif italic text-xl sm:text-2xl text-forest/80">{item}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-gold" />
          </span>
        ))}
      </div>
    </div>
  );
}
